import PageHero from "../components/site/PageHero";
import LeadForm from "../components/site/LeadForm";
import Guarantee from "../components/site/Guarantee";
import FAQ from "../components/site/FAQ";
import { usePageSEO, breadcrumb } from "../hooks/usePageSEO";

export default function Contacto() {
  usePageSEO({
    title: "Contacto · Agenda una Consultoría | Daos Ads",
    description:
      "Agenda una consultoría con David Osorio (Daos Ads). Cuéntame qué necesitas automatizar y en menos de 24 horas te respondo personalmente. WhatsApp +502 4337 6954.",
    path: "/contacto",
    jsonLd: [
      breadcrumb([
        { name: "Inicio", path: "/" },
        { name: "Contacto", path: "/contacto" },
      ]),
      {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: "Contacto Daos Ads",
        url: "https://daosads.com/contacto",
        about: { "@id": "https://daosads.com/#organization" },
      },
    ],
  });

  return (
    <main>
      <PageHero
        eyebrow="Contacto"
        title="Hablemos de tu sistema de"
        highlight="adquisición y ventas"
        description="Cuéntame brevemente tu operación, canales y objetivos. En menos de 24 horas te respondo personalmente — no un account manager, no un bot."
        primaryCta={null}
      />

      {/* Lead form */}
      <LeadForm />

      {/* Guarantee */}
      <Guarantee />

      {/* FAQ */}
      <FAQ />
    </main>
  );
}
